import React, { useState, useRef, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import './Pages/PagesCss/NavBar.css';
import logo from '../components/assets/logo.png';

const NavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSubMenu, setMobileSubMenu] = useState(null);
  const navRef = useRef(null);
  const location = useLocation();

  const toggleMobile = () => {
    setMobileOpen(!mobileOpen);
    if (!mobileOpen) {
      setMobileSubMenu(null);
    }
  };

  const closeMobileMenu = () => {
    setMobileOpen(false);
    setMobileSubMenu(null);
  };

  const openMobileSubMenu = (index) => setMobileSubMenu(index);
  const closeMobileSubMenu = () => setMobileSubMenu(null);

  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileOpen]);

  const handleMobileKeyDown = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openMobileSubMenu(index);
    } else if (event.key === 'Escape') {
      closeMobileSubMenu();
    }
  };

  const menuItems = [
    {
      name: "Payroll",
      dropdown: [
        { name: "Payroll Calculator", path: "/PayrollCalculatorUSA" },
        { name: "Income Tax Calculator", path: "/IncomeTaxCalculatorUSA" },
        { name: "Tax Reports Generator", path: "/TaxReportsUSA" },
      ]
    },
    {
      name: "Estate",
      dropdown: [
        { name: "Property Tax Calculator", path: "/PropertyTaxCalculatorUSA" },
        { name: "Inheritance Tax Calculator", path: "/InheritanceTaxCalculatorUSA" },
        { name: "Capital Gains Tax Calculator", path: "/CapitalGainsCalculatorUSA" },
        { name: "Estate Planning Calculator", path: "/EstatePlanningCalculatorUSA" },
      ]
    },
    {
      name: "Tax",
      dropdown: [
        { name: "Tax Return Calculator", path: "/TaxReturnCalculatorUSA" },
        { name: "Tax Refund Calculator", path: "/TaxRefundCalculatorUSA" },
        { name: "Retirement Tax Calculator", path: "/RetirementTaxCalculatorUSA" },
        { name: "Pension Tax Calculator", path: "/PensionTaxCalculatorUSA" },
      ]
    },
    {
  name: "Time & Pay",
  dropdown: [
    { name: "Time Card Calculator", path: "/TimeCardCalculator" },
    { name: "Hours to Decimal Converter", path: "/HoursToDecimalConverter" },
    { name: "Billing Hours Calculator", path: "/BillingHoursCalculator" },
    { name: "Timesheet Converter", path: "/TimesheetConverter" },
    { name: "Salary to Hourly Calculator", path: "/SalaryToHourlyCalculator" },
    { name: "Hourly to Salary Calculator", path: "/HourlyToSalaryCalculator" },
    { name: "Time-Off Accrual Calculator", path: "/TimeOffAccrualCalculator" },
    { name: "Overtime Calculator", path: "/OvertimeCalculator" },
    { name: "Break Time Calculator", path: "/BreakTimeCalculator" },
  ]
},
    { name: "About", path: "/AboutUs" },
    { name: "Contact", path: "/Contact" },
  ];

  return (
    <header className="tax-header" ref={navRef} role="navigation" aria-label="Main navigation">
      <div className="tax-header__container">
        {/* Brand/Logo for all screens */}

        <NavLink to="/" className="tax-mobile-menu__brand" onClick={closeMobileMenu}
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <img src={logo} alt="Logo" className="tax-mobile-menu__logo" />
              <span className="tax-mobile-menu__brand-text">AfterTaxPay.net</span>
            </NavLink> 

        {/* Single Menu Button for both desktop and mobile */}
        <button 
          className={`tax-header__menu-btn ${mobileOpen ? "tax-header__menu-btn--active" : ""}`}
          onClick={toggleMobile}
          aria-expanded={mobileOpen}
          aria-label="Toggle navigation menu"
          aria-controls="tax-mobile-menu"
        >
          <span className="tax-header__menu-btn-line"></span>
          <span className="tax-header__menu-btn-line"></span>
          <span className="tax-header__menu-btn-line"></span>
          <span className="tax-header__sr-only">Menu</span>
        </button>

        {/* Enhanced Slide-in Navigation */}
        <nav 
          id="tax-mobile-menu"
          className={`tax-mobile-menu ${mobileOpen ? "tax-mobile-menu--open" : ""}`}
          aria-label="Main navigation"
        >
          <div className="tax-mobile-menu__header">
            <div className="tax-mobile-menu__brand">
              <img src={logo} alt="Logo" className="tax-mobile-menu__logo" />
              <span className="tax-mobile-menu__brand-text">AfterTaxPay.net</span>
            </div>
          </div>

          <div className="tax-mobile-menu__content">
            {mobileSubMenu === null ? (
              <div className="tax-mobile-menu__main" role="menu">
                <h3 className="tax-mobile-menu__title">Tax Calculators</h3>
                <div className="tax-mobile-menu__items">
                  {menuItems.map((item, idx) => (
                    <div key={idx} className="tax-mobile-menu__item" role="none">
                      {item.dropdown ? (
                        <button
                          className="tax-mobile-menu__link tax-mobile-menu__dropdown-btn"
                          onClick={() => openMobileSubMenu(idx)}
                          onKeyDown={(e) => handleMobileKeyDown(e, idx)}
                          role="menuitem"
                          aria-expanded="false"
                        >
                          <span className="tax-mobile-menu__link-text">{item.name}</span>
                          <span className="tax-mobile-menu__arrow" aria-hidden="true">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M4.5 9L7.5 6L4.5 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                        </button>
                      ) : (
                        <NavLink 
                          to={item.path} 
                          className="tax-mobile-menu__link"
                          onClick={closeMobileMenu}
                          role="menuitem"
                          tabIndex={mobileOpen ? 0 : -1}
                        >
                          <span className="tax-mobile-menu__link-text">{item.name}</span>
                        </NavLink>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="tax-mobile-menu__submenu" role="menu">
                <button 
                  className="tax-mobile-menu__back-btn" 
                  onClick={closeMobileSubMenu}
                  role="menuitem"
                  tabIndex={mobileOpen ? 0 : -1}
                >
                  <span className="tax-mobile-menu__back-icon" aria-hidden="true">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M10 13L5 8L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <span className="tax-mobile-menu__back-text">Back</span>
                </button>
                
                <div className="tax-mobile-menu__submenu-content">
                  <h3 className="tax-mobile-menu__submenu-title">
                    {menuItems[mobileSubMenu].name}
                  </h3>
                  <div className="tax-mobile-menu__submenu-items">
                    {menuItems[mobileSubMenu].dropdown.map((link, lIdx) => (
                      <NavLink
                        key={lIdx}
                        to={link.path}
                        className={`tax-mobile-menu__submenu-link ${location.pathname === link.path ? 'tax-mobile-menu__submenu-link--active' : ''}`}
                        onClick={closeMobileMenu}
                        role="menuitem"
                        tabIndex={mobileOpen ? 0 : -1}
                      >
                        <span className="tax-mobile-menu__submenu-link-text">{link.name}</span>
                        {location.pathname === link.path && (
                          <span className="tax-mobile-menu__active-indicator" aria-hidden="true">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M3 8L6 11L13 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </span>
                        )}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Mobile Menu Footer */}
          <div className="tax-mobile-menu__footer">
            <div className="tax-mobile-menu__footer-glow"></div>
            <p className="tax-mobile-menu__footer-text">Professional Tax Calculators & Financial Tools</p>
          </div>
        </nav>

        {/* Overlay for mobile menu */}
        <div 
          className={`tax-mobile-menu__overlay ${mobileOpen ? "tax-mobile-menu__overlay--active" : ""}`}
          onClick={closeMobileMenu}
          aria-hidden="true"
        />
      </div>
    </header>
  );
};

export default NavBar;